import React from "react";
import { twMerge } from "tailwind-merge";

const FormErrorLabel = ({ message, className = '' }) => message ?
    <p className={twMerge(`error-message my-2 text-sm text-free-speech-red ${className}`)}>{message}</p> : null;

export default FormErrorLabel;
